export default __webpack_public_path__ + "img/jnpt.logo.9269060b.jpg";